import pdf from '@/sui/tools/pdf'
import ctool from 'color'
import moment from 'moment'

const blue = '#0b89c0'
const gray = '#455565'
const lightblue = ctool(blue).lighten(1.2).hex()
function v4 (v) {
  return [v, v, v, v]
}

function sectionTitle (t, pb) {
  const result = {
    style: 'h3',
    layout: 'noBorders',
    table: {
      widths: ['*'],
      body: [[
        { text: t, fillColor: blue }
      ]]
    }
  }

  if (pb) {
    result.pageBreak = 'before'
  }
  return result
}

const field = (n) => {
  return {
    text: n,
    borderColor: v4('#ffffff'),
    style: 'field'
  }
}

const answer = (n) => {
  return {
    text: n,
    borderColor: v4('#ffffff'),
    fillColor: lightblue,
    style: 'answer'
  }
}

function establishmentForm (info) {
  return {
    table: {
      widths: [60, '*'],
      body: [
        [field('Nom :'), answer(info.name)],
        [field('Adresse :'), answer(info.address)],
        [field('N° Finess :'), answer(info.finess)]
      ]
    }
  }
}

function signatureBox () {
  return {
    margin: [0, 3],
    table: {
      widths: [130],
      heights: [85],
      body: [[
        {
          text: 'SIGNATURE',
          style: 'signature'
        }
      ]]
    },
    borderColor: v4(blue)
  }
}

function signature (t, i, s) {
  const stack = [ { text: t, style: { color: blue, bold: true } } ]
  stack.push(s != null ? s : ' ')
  stack.push(
    {
      table: {
        widths: [50, '*'],
        body: [
          [field('Nom :'), answer(i.name)],
          [field('Prénom :'), answer(i.firstName)],
          [field('E-mail :'), answer(i.email)]
        ]
      }
    }
  )

  return {
    margin: [0, 10],
    layout: {
      defaultBorder: true
    },
    style: 'signatureBox',
    table: {
      widths: ['*', 140],
      body: [
        [
          {
            stack: stack,
            border: [false, false, true, false],
            borderColor: v4(blue)
          },
          signatureBox()
        ]
      ]
    }
  }
}

function bluebox (s) {
  return {
    margin: [0, 20],
    layout: 'noBorders',
    table: {
      widths: ['*'],
      body: [
        [
          {
            stack: s,
            fillColor: blue,
            style: 'p3'
          }
        ]
      ]
    }
  }
}

function agreement () {
  return bluebox(
    [
      {
        text: 'Pour formaliser l’inscription de votre établissement à la SPIADI, il est nécessaire :',
        margin: [0, 0, 0, 10]
      },
      {
        ol: [
          [
            {
              text: 'de présenter le programme SPIADI (surveillance / observations des pratiques)',
              margin: [0, 0, 0, 10]
            },
            {
              ul: [
                'au DIRECTEUR GÉNÉRAL de l’établissement ou son(sa) représentant(e)',
                'au BIOLOGISTE en charge des analyses de bactériologie pour l’établissement.'
              ]
            }
          ],
          {
            text: 'et obtenir leur accord signé.',
            margin: [0, 10, 0, 0]
          }
        ]
      }
    ]
  )
}

function limit () {
  return bluebox(
    [
      {
        text: `La charte remplie et signée est à renvoyer à l’équipe SPIADI via le module d’inscription de l’application informatique.`,
        margin: [0, 0, 0, 10]
      },
      `Tout changement de personne citée ci-dessus doit entraîner une information à l’équipe de la SPIADI et une modification des accords de participation sur le site spiadi.fr.`
    ]
  )
}

function participation () {
  const uli = (t, u = 10, b = 10) => {
    return {
      text: t,
      margin: [0, u, 0, b]
    }
  }

  return {
    stack: [
      `Par la signature des accords de participation ci-dessous, vous reconnaissez avoir pris connaissance des protocoles du programme SPIADI et vous engager, conformément aux attributions et délégations dont vous bénéficiez, pour le compte de l’établissement cité ci-dessus à :`,
      {

        ul: [
          uli('participer à la mission nationale SPIADI pendant 1 an, renouvelable chaque année par tacite reconduction. Le responsable SPIADI a automatiquement accès aux résultats de l’année en cours et des années antérieures (à compter de 2019). Il pourra désigner d’autres destinataires des résultats.'),
          {
            stack: [
              'veiller à la bonne application du protocole et notamment respecter et faire respecter à toute personne agissant sous votre responsabilité, les obligations suivantes :',
              {
                ul: [
                  uli('le secret professionnel ;', 3, 3),
                  uli('assurer le respect des droits des patients ;', 3, 3),
                  uli('informer les patients de la réalisation du programme SPIADI ;', 3, 3),
                  uli('transmettre les données requises selon les modalités déterminées par le protocole (fiche présentant les caractéristiques de l’établissement, les données de surveillance anonymisées et les dénominateurs nécessaires à l’analyse des résultats) ;', 3, 3)
                ],
                type: 'circle'
              }
            ],
            margin: [0, 0, 10, 0]
          },
          uli(
            [
              'signaler le cas échéant, à l’adresse suivante : ',
              { text: 'contact@spiadi.fr', style: 'link' },
              ', toute faille de sécurité et toute violation de données à caractère personnel impactant la mission SPIADI ;'
            ]
          ),
          uli(
            [
              'signaler le cas échéant toute modification de personne ayant signé les accords de participation à l’adresse ',
              { text: 'contact@spiadi.fr', style: 'link' },
              'et à mettre à jour la charte (nom, prénom, mail et signature du remplaçant).'
            ],
            10,
            0
          )
        ]
      }
    ],
    style: 'p2'
  }
}

function getImageData (file, key, type) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.onload = () => {
      if (type !== 'svg') {
        const reader = new FileReader()
        reader.onload = () => {
          resolve({ data: reader.result, key: key, type: type })
        }
        reader.onerror = error => reject(error)
        reader.readAsDataURL(xhr.response)
      } else {
        resolve({ data: xhr.responseText, key: key, type: type })
      }
    }
    xhr.open('GET', file)
    xhr.responseType = type !== 'svg' ? 'blob' : 'text'
    xhr.send()
  })
}

function exportPDF (info) {
  const load = [
    getImageData(require('@/assets/img/logo-repias.png'), 'repias', 'png'),
    getImageData(require('@/assets/img/logo-spf.svg'), 'spf', 'svg')
  ]

  Promise.all(load).then(
    (v) => {
      const imgs = {}
      for (let i in v) {
        const img = v[i]
        imgs[img.key] = img
      }
      doExport(imgs, info)
    }
  )
}

function doExport (imgs, info) {
  const styles = {
    h1: {
      fontSize: 35,
      margin: [0, 90, 0, 5],
      color: gray,
      alignment: 'center'
    },

    subh1b: {
      fontSize: 20,
      bold: true
    },

    subh1: {
      margin: [20, 0, 20, 40],
      fontSize: 16,
      color: gray,
      alignment: 'center'
    },

    h2: {
      fontSize: 18,
      margin: [0, 20, 0, 60],
      color: gray,
      bold: true,
      alignment: 'center'
    },

    h2b: {
      fontSize: 18,
      color: gray,
      bold: true,
      alignment: 'center',
      margin: [0, 5, 0, 0]
    },

    h3: {
      fontSize: 14,
      color: '#ffffff',
      bold: true,
      alignment: 'center',
      margin: [0, 20, 0, 5]
    },

    p2: {
      fontSize: 12,
      color: gray,
      bold: true,
      alignment: 'justify',
      margin: [0, 20, 0, 0]
    },

    p3: {
      fontSize: 12,
      color: '#ffffff',
      bold: true,
      margin: [10, 5, 10, 5]
    },

    field: {
      color: gray,
      alignment: 'right',
      bold: true
    },

    answer: {
      color: gray,
      fontSize: 13
    },

    link: {
      color: blue,
      decoration: 'underline'
    },

    signature: {
      alignment: 'center',
      fontSize: 9,
      color: gray
    },

    signatureBox: {
      color: gray
    }
  }

  const upf = (f) => { return { text: f, style: 'subh1b' } }
  const img = (d, w, s) => {
    const result = { width: w, style: s }
    if (d.type !== 'svg') {
      result.image = d.data
    } else {
      result.svg = d.data
    }
    return result
  }

  const content = [
    {
      layout: 'noBorders',
      table: {
        widths: ['*', '*'],
        body: [[
          img(imgs.repias, 120),
          img(imgs.spf, 120, { alignment: 'right' })
        ]]
      }
    }
  ]

  if (info.complete) {
    content.push(
      { text: 'PROGRAMME SPIADI', style: 'h1' },
      {
        text: [
          upf('S'), 'urveillance et ', upf('P'), 'révention des ',
          upf('I'), 'nfections ', upf('A'), 'ssociées aux ',
          upf('D'), 'ispositifs ', upf('I'), 'nvasifs'
        ],
        style: 'subh1'
      },
      {
        text: `CHARTE D'ENGAGEMENT`,
        style: 'h2'
      },
      {
        text: `En application des dispositions de l’article R. 1413-86 du code de la santé publique et de la convention de partenariat n°18DMIP024-0, le CPIAS Centre val de Loire a été désigné par Santé publique France afin de mettre en œuvre la mission nationale dénommée «Surveillance et Prévention des Infections Associées aux Dispositifs Invasifs» dite SPIADI.`,
        style: 'p2'
      },
      {
        text: `Le CPIAS est responsable du traitement de données à caractère personnel mis en œuvre pour la réalisation de la mission nationale SPIADI. Il assure la conformité de ce traitement aux dispositions législatives et réglementaires applicables en matière de protection des données à caractère personnel. A ce titre, le CPIAS s’engage notamment à veiller à la sécurité des données transmises par les établissements adhérant au programme de la mission SPIADI , en empêchant qu’elles ne soient déformées, altérées, communiquées à un tiers non autorisé, sous réserve des éventuelles obligations légales et réglementaires contraires. Le CPIAS s’engage à ne traiter les données transmises que pour les finalités du programme de la mission SPIADI.`,
        style: 'p2'
      },
      sectionTitle('VOTRE ÉTABLISSEMENT', true),
      establishmentForm(info.establishment),
      agreement(),
      participation(),
      sectionTitle('ACCORDS DE PARTICIPATION', true)
    )
  } else {
    content.push(
      {
        text: `SPIADI - AVENANT À LA CHARTE D'ENGAGEMENT`,
        style: 'h2b'
      },
      sectionTitle('VOTRE ÉTABLISSEMENT'),
      establishmentForm(info.establishment),
      participation(),
      sectionTitle('ACCORD DE PARTICIPATION')
    )
  }

  if (info.dir != null) {
    content.push(
      signature(`DIRECTEUR DE L'ÉTABLISSEMENT`, info.dir, 'ou son représentant')
    )
  }

  if (info.reg != null) {
    content.push(
      signature('RESPONSABLE SPIADI', info.reg)
    )
  }

  if (info.bio != null) {
    content.push(
      signature('BIOLOGISTE EN CHARGE DE VOTRE ÉTABLISSEMENT', info.bio)
    )
  }

  if (info.complete) {
    content.push(limit())
  }

  const now = moment().format('DD/MM/YYYY')
  const type = info.complete
    ? `CHARTE D'ENGAGEMENT`
    : `AVENANT ${info.dir != null ? 'DIRECTEUR'
      : info.reg != null ? 'RESPONSABLE' : 'BIOLOGISTE'}`
  const filename =
        `SPIADI${info.year} - ${type} - ${info.establishment.name}`
  const definition = {
    pageStyle: 'A4',
    content: content,
    styles: styles,
    footer: (current, count) => {
      return {
        text: `${filename} - ${now} - page ${current}/${count}`,
        fontSize: 6,
        alignment: 'center'
      }
    }
  }
  pdf.createPdf(definition).download(`${filename}.pdf`)
}

function glyph (g) {
  return `
<span class="glyphicon glyphicon-${g}" aria-hidden="true"
      style="margin-right: 0.7rem;">
</span>`
}

function getDefaultAlert () {
  return {
    type: 'warning',
    body: '',
    send: false,
    generate: false,
    edit: false,
    bio: false,
    dir: false,
    reg: false
  }
}

function getMemberAlert (cvt, error) {
  const result = getDefaultAlert()

  if (cvt.main === 0) {
    result.body = `
<p>
  <strong>
    ${glyph('time')}
    En attente de la charte
  </strong>
</p>
<p>
  Le responsable du programme doit désigner les signataires de la charte.
</p>`
    return result
  }

  if (cvt.main === 1) {
    result.body = `
<p>
  <strong>
    ${glyph('time')}
    En attente de la charte
  </strong>
</p>
<p>
  Le responsable du programme doit nous renvoyer la charte signée.
</p>`
    return result
  }

  if (cvt.main >= 2) {
    if (cvt.stat === 1) {
      result.type = 'info'
      const s = cvt.main === 3 ? 'Document.s' : 'Charte'
      const b = cvt.main === 3
        ? 'le.s document.s, le tout sera vérifié'
        : 'la charte, celle-ci sera vérifiée'
      result.body = `
<p>
  ${glyph('time')}
  <strong>
    ${s} en cours de validation...
  </strong>
<p>
<p>
  Nous avons bien reçu ${b} dans les plus brefs délais.
<p>`
      return result
    }

    if (cvt.stat === 3) {
      result.type = 'danger'
      result.body = `
<p>
  ${glyph('alert')}
  <strong>Charte refusée !</strong>
</p>
<p>
  Le responsable du programme doit nous renvoyer le.s document.s corrigé.s.
</p>
`
      return result
    }

    if (cvt.stat === 4) {
      result.type = 'warning'
      result.body = `
<strong>
  ${glyph('time')}
  En attente du ou des avenants à la charte.
</strong>`
      return result
    }

    if (cvt.stat === 2) {
      result.type = 'success'
      result.body = `
<span>
  ${glyph('ok')}
  <strong>Charte acceptée.</strong>
</span>`
      return result
    }

    if (cvt.main >= 2 || cvt.stat === 0) {
      result.body = `
<strong>
  ${glyph('time')}
  En attente de la charte.
</strong>
`
      return result
    }
  }

  return result
}

function getRegistratorAlert (user, cvt, error) {
  const result = getDefaultAlert()

  if (cvt.main === 0) {
    result.body = `
<p>
  Afin de compléter votre inscription à la surveillance SPIADI, merci
  de bien vouloir remplir la charte d'engagement.
</p>
<p>
  Il vous faut :
  <ul>
    <li>
      désigner les signataires de la charte
    </li>
    <li>
      télécharger le document et le faire signer par tous les signataires
    </li>
    <li>
      nous faire parvenir le document
      <small>(via cet espace ou par e-mail)</small>
    </li>
  </ul>
</p>`
    result.roles = true
    return result
  }

  if (cvt.main === 1) {
    result.body = `
<p>
  Vous pouvez désormais télécharger le document à faire signer ou rectifier les
  signataires. Une fois le document signé, merci de nous le renvoyer.
</p>`
    result.generate = true
    result.roles = true
    result.send = true
    return result
  }

  if (cvt.main >= 2) {
    if (cvt.stat === 1) {
      result.type = 'info'
      const s = cvt.main === 3 ? 'Document.s' : 'Charte'
      const b = cvt.main === 3
        ? 'le.s document.s, le tout sera vérifié'
        : 'votre charte, celle-ci sera vérifiée'
      result.body = `
<p>
  ${glyph('time')}
  <strong>
    ${s} en cours de validation...
  </strong>
</p>
<p>
  Nous avons bien reçu ${b} dans les plus brefs délais.
</p>
<p>
  Vous avez toujours la possibilité de modifier les signataires en utilisant
  le bouton ci-dessous.
</p>`
      result.roles = true
      return result
    }

    if (cvt.stat === 3) {
      result.type = 'warning'
      const target = cvt.main === 3
        ? 'Un ou plusieurs avenants ont été refusés'
        : 'La charte a été refusée'
      result.body = `
<p>
  ${glyph('alert')}
  <strong>Attention !</strong>
</p>
<p>
  ${target} pour la raison suivante :
</p>
<div class="alert alert-danger">
  <p>
    <strong>${error}</strong>
  </p>
</div>
<p>
  Merci de nous renvoyer le.s document.s corrigé.s en tenant compte
  des indications ci-dessus. Vous pouvez également modifier les
  signataires (si nécessaire) à l'aide du bouton ci-dessous.
</p>`
      result.roles = true
      if (cvt.main !== 3) {
        result.send = true
      } else {
        result.bio = cvt.bio.stat === 3 ? null : cvt.bio.stat
        result.dir = cvt.dir.stat === 3 ? null : cvt.dir.stat
        result.reg = cvt.reg.stat === 3 ? null : cvt.reg.stat
      }

      return result
    }

    if (cvt.stat === 4) {
      result.type = 'warning'
      result.body = `
<p>
  Vous pouvez désormais télécharger le.s document.s à faire signer. Une fois
  les document.s signé.s, merci de nous le.s renvoyer.
</p>
<p>
  Votre demande sera examinée par notre équipe une fois tous les documents reçus.
</p>`

      result.bio = cvt.bio.stat === 3 ? null : cvt.bio.stat
      result.dir = cvt.dir.stat === 3 ? null : cvt.dir.stat
      result.reg = cvt.reg.stat === 3 ? null : cvt.reg.stat
      result.roles = true
      return result
    }

    if (cvt.stat === 2) {
      result.type = 'success'
      result.body = `
<p>
  ${glyph('ok')}
  <strong>Charte validée pour le programme SPIADI2026.</strong>
</p>
`
      result.roles = true
      return result
    }

    if (cvt.main >= 2 || cvt.stat === 0) {
      if (cvt.main !== 3 ||
          (cvt.reg.stat !== 1 && cvt.bio.stat !== 1 && cvt.dir.stat !== 1)) {
        result.body = `
<p>
  Une charte existe pour votre établissement avec les signataires suivants :
</p>
<ul>
  <li>
    <strong>Responsable</strong><br />
    ${cvt.reg.fn} ${cvt.reg.name} (${cvt.reg.eml})
  </li>
  <li>
    <strong>Directeur <small>(ou son représentant)</small></strong><br />
    ${cvt.dir.fn} ${cvt.dir.name} (${cvt.dir.eml})
  </li>
  <li>
    <strong>Biologiste</strong><br />
    ${cvt.bio.fn} ${cvt.bio.name} (${cvt.bio.eml})
  </li>
</ul>
`
        const isSameRegistrator = `${cvt.reg.fn} ${cvt.reg.name}` === user.name &&
              cvt.reg.eml === user.email
        if (isSameRegistrator) {
          result.confirm = true
          result.body += `
<p>
  Vous pouvez reconduire la charte ou modifier les signataires avec
  les boutons ci-dessous.
</p>
`
        } else {
          result.body += `
<div class='alert alert-info'>
  <p>
    <strong>
      Le responsable de la surveillance a changé, merci d'enregistrer les nouveaux
      signataires à l'aide du bouton ci-dessous.
    </strong>
  </p>
</div>
`
        }

        result.roles = true
      } else {
        result.type = 'warning'
        result.body = `
<p>
  ${glyph('alert')}
  <strong>Attention !</strong>
</p>
<p>
  Une charte existe pour votre établissement mais il y a un ou plusieurs
  avenant.s en attente.
</p>
<p>
  Merci de nous renvoyer le.s document.s corrigé.s. Vous pouvez également
  modifier les signataires (si nécessaire) à l'aide du bouton ci-dessous.
</p>`
        result.roles = true
        result.bio = cvt.bio.stat === 3 ? 0 : cvt.bio.stat
        result.dir = cvt.dir.stat === 3 ? 0 : cvt.dir.stat
        result.reg = cvt.reg.stat === 3 ? 0 : cvt.reg.stat
      }
      return result
    }
  }

  return result
}

export default {
  exportPDF: exportPDF,
  getMemberAlert: getMemberAlert,
  getRegistratorAlert: getRegistratorAlert

}
